/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SigfoxDeviceCheckRecord from './SigfoxDeviceCheckRecord';

/**
* The CreateSigfoxDeviceResponse model module.
* @module model/CreateSigfoxDeviceResponse
* @version 2020-12-7
*/
export default class CreateSigfoxDeviceResponse {
    /**
    * Constructs a new <code>CreateSigfoxDeviceResponse</code>.
    * Sigfoxのデバイス登録成功レスポンス
    * @alias module:model/CreateSigfoxDeviceResponse
    * @class
    * @param result {module:model/CreateSigfoxDeviceResponse.ResultEnum} 結果
    * @param serialNo {String} シリアル番号
    * @param record {module:model/SigfoxDeviceCheckRecord} 
    */

    constructor(result, serialNo, record) {
        
        
        this['result'] = result;
        this['serialNo'] = serialNo;
        this['record'] = record;
        
    }

    /**
    * Constructs a <code>CreateSigfoxDeviceResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateSigfoxDeviceResponse} obj Optional instance to populate.
    * @return {module:model/CreateSigfoxDeviceResponse} The populated <code>CreateSigfoxDeviceResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateSigfoxDeviceResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
            if (data.hasOwnProperty('record')) {
                obj['record'] = SigfoxDeviceCheckRecord.constructFromObject(data['record']);
            }
        }
        return obj;
    }

    /**
    * 結果
    * @member {module:model/CreateSigfoxDeviceResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * シリアル番号
    * @member {String} serialNo
    */
    'serialNo' = undefined;
    /**
    * @member {module:model/SigfoxDeviceCheckRecord} record
    */
    'record' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
